import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import './AdminDesign.css';

import Home from './pages/Home';
import Alunos from './pages/Alunos';
import Academias from './pages/Academias';
import Categorias from './pages/Categorias';
import TabelasPeso from './pages/TabelasPeso';
import Campeonatos from './pages/Campeonatos';
import Chaves from './pages/Chaves';
import GerarChaves from './pages/GerarChaves';
import Relatorios from './pages/Relatorios';
import Financeiro from './pages/Financeiro';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import {
  IconHome, IconTrophy, IconUsers, IconAcademy, IconTag,
  IconScale, IconBracket, IconBolt, IconChart, IconUser, IconWallet,
} from './components/icons';

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const isLoggedIn = sessionStorage.getItem('userLoggedIn') === 'true';
  const userEmail = sessionStorage.getItem('userEmail');

  // Não mostrar sidebar na página de login
  if (location.pathname === '/login') {
    return null;
  }

  const handleLogout = () => {
    sessionStorage.removeItem('userLoggedIn');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('token');
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname.startsWith(path) && (path !== '/' || location.pathname === '/');
  };

  const menuItems = [
    { path: '/', icon: IconHome, label: 'Home' },
    { path: '/campeonatos', icon: IconTrophy, label: 'Campeonatos' },
    { path: '/financeiro', icon: IconWallet, label: 'Financeiro' },
    { path: '/alunos', icon: IconUsers, label: 'Alunos' },
    { path: '/academias', icon: IconAcademy, label: 'Academias' },
    { path: '/categorias', icon: IconTag, label: 'Categorias' },
    { path: '/tabelas-peso', icon: IconScale, label: 'Tabelas de Peso' },
    { path: '/chaves', icon: IconBracket, label: 'Chaves' },
    { path: '/gerar-chaves', icon: IconBolt, label: 'Gerar Chaves', highlight: true },
    { path: '/relatorios', icon: IconChart, label: 'Relatórios' },
  ];

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <svg className="logo-icon" width="28" height="28" viewBox="0 0 30 30" fill="none">
            <path d="M15 2L27 9V21L15 28L3 21V9L15 2Z" stroke="#DC2626" strokeWidth="2"/>
            <path d="M15 2V28M3 9L27 21M27 9L3 21" stroke="#DC2626" strokeWidth="1"/>
          </svg>
          {!collapsed && <h2>SIGE</h2>}
        </div>
        <button 
          className="sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expandir menu' : 'Recolher menu'}
        >
          {collapsed ? '▶' : '◀'}
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-menu">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${isActive(item.path) ? 'active' : ''} ${item.highlight ? 'highlight' : ''}`}
                  title={collapsed ? item.label : ''}
                >
                  <span className="nav-icon"><Icon /></span>
                  {!collapsed && <span className="nav-label">{item.label}</span>}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {isLoggedIn && (
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              <IconUser />
            </div>
            {!collapsed && (
              <div className="user-details">
                <span className="user-email" title={userEmail}>{userEmail?.split('@')[0]}</span>
                <button onClick={handleLogout} className="btn-logout">
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </aside>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Sidebar />

        <main className="main-content">
          <div className="app-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
              <Route path="/campeonatos/*" element={<PrivateRoute><Campeonatos /></PrivateRoute>} />
              <Route path="/financeiro" element={<PrivateRoute><Financeiro /></PrivateRoute>} />
              <Route path="/alunos" element={<PrivateRoute><Alunos /></PrivateRoute>} />
              <Route path="/academias" element={<PrivateRoute><Academias /></PrivateRoute>} />
              <Route path="/categorias" element={<PrivateRoute><Categorias /></PrivateRoute>} />
              <Route path="/tabelas-peso" element={<PrivateRoute><TabelasPeso /></PrivateRoute>} />
              <Route path="/chaves" element={<PrivateRoute><Chaves /></PrivateRoute>} />
              <Route path="/gerar-chaves" element={<PrivateRoute><GerarChaves /></PrivateRoute>} />
              <Route path="/relatorios" element={<PrivateRoute><Relatorios /></PrivateRoute>} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
